import { useEffect, useState } from 'react';

import { BlockTitle } from '@/components/old';

import { DictionaryPermitType, ERZPermit, Weapon } from '@/api/types';

import api from '@/api';

import { Loader } from '@/shared/ui';
import { StepsNavigationName } from '../../../../../../config/services';
import { PermitListWithWeapons } from '../../../../components/PermitListWithWeapons/PermitListWithWeapons';

interface Props {
  currentRequests: ERZPermit[];
}

const Step1: React.FC<Props> = ({ currentRequests }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [extractTypes, setExtractTypes] = useState<DictionaryPermitType[]>([]);
  const [userWeapons, setUserWeapons] = useState<Weapon[]>([]);

  useEffect(() => {
    setIsLoading(true);
    Promise.all([api.dictionary.getPermitTypes(), api.getWeaponsData()])
      .then(([{ data: responseExtractTypes }, { data: responseWeapons }]) => {
        setExtractTypes(responseExtractTypes);
        setUserWeapons([...responseWeapons.criminalItems, ...responseWeapons.ipsItems]);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <>
      <BlockTitle id="step-description" paddingBottomMdExtra bgLight>
        {StepsNavigationName.permissionData}
      </BlockTitle>
      {isLoading ? (
        <Loader centered />
      ) : (
        <PermitListWithWeapons
          erzExtracts={currentRequests}
          getExtractTypeName={(extractLabel): Nullable<string> =>
            extractTypes.find((extractType) => extractType.label === extractLabel)?.name
          }
          userWeapons={userWeapons}
        />
      )}
    </>
  );
};

export default Step1;
